import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NgClass } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TsButtonModule } from 'tsui';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TaskStatusService } from '@tasks/services/task-status.service';
import { TaskStatus } from '@tasks/tasks.types';

@Component({
  standalone: true,
  imports: [
    MatIconModule,
    NgClass,
    RouterModule,
    TsButtonModule,
    NgClass,
    MatProgressBarModule,
    MatTooltipModule,
    TsButtonModule,
  ],
  selector: 'table-task-project-renderer',
  template: `<span class="underline cursor-pointer" (click)="openProject()"
    >{{ this.task?.project?.title || this.task?.project_title }}
  </span>`,
})
export class TableTasksProjectRendererComponent implements ICellRendererAngularComp {
  params;
  task;
  workflowStates;
  taskStatusService = inject(TaskStatusService);

  router = inject(Router);

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.task = params.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  openProject() {
    if (this.task.project_id) {
      this.router.navigate(['/projects', this.task.pipeline_id, this.task.project_id, 'details', 'overview']);
    }
  }
}
